import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '@/common/SafeIcon';
import { advantagesData } from '@/data/content';

const Advantages = () => {
  return (
    <section id="keunggulan" className="py-32 bg-slate-900 text-white relative overflow-hidden">
      {/* Elegant background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-accent via-transparent to-transparent"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="w-8 h-px bg-accent"></div>
            <span className="text-accent font-medium tracking-[0.2em] uppercase text-xs">Nilai Kami</span>
            <div className="w-8 h-px bg-accent"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-serif mb-6">
            Mengapa Memilih Kami
          </h2>
          <p className="text-gray-400 font-light text-lg">
            Dedikasi tanpa kompromi untuk menghadirkan pengalaman perjalanan yang aman, nyaman, dan tak terlupakan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {advantagesData.map((item, index) => (
            <motion.div 
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              className="relative group p-8 bg-slate-800/50 hover:bg-slate-800 rounded-sm border border-slate-700/50 transition-all duration-500"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-accent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              
              <div className="w-14 h-14 mb-8 text-accent animate-float" style={{ animationDelay: `${index * 0.5}s` }}>
                <SafeIcon name={item.icon} className="w-full h-full stroke-[1.5]" />
              </div>
              <h3 className="text-xl font-serif mb-4 text-white">{item.title}</h3>
              <p className="text-gray-400 font-light leading-relaxed text-sm">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;